// #region Imports
import PropTypes from "prop-types"
import React, { useState, useEffect } from "react"
import { useDispatch } from "react-redux"
import { ToastContainer, toast } from "react-toastify"
import "react-toastify/dist/ReactToastify.css"
import { Modal, ModalBody } from "reactstrap"
import classname from "classnames"
import classnames from "classnames"
import {
  AccordionBody,
  AccordionHeader,
  AccordionItem,
  Card,
  CardBody,
  CardText,
  CardTitle,
  Col,
  Collapse,
  Container,
  Nav,
  NavItem,
  NavLink,
  Row,
  TabContent,
  TabPane,
  UncontrolledAccordion,
  UncontrolledCollapse,
} from "reactstrap"

import DatosGenerales from "./DatosGenerales"
import Direccion from "./Direccion"
import DatosAcademicos from "./DatosAcademicos"
import Documentacion from "./Documentacion"
// import Cargos from "./Cargos"
// import Kardex from "./Kardex"

// #endregion

// #region selectors
import {
  useControlEscolaroPersona,
  useAuthPermiso,
  useControlEscolarError,
  useControlEscolaroNotificacion,
  useAuthIdPersonaAuthenticated,
  useControlEscolaroPhotoCredencial,
  useControlEscolarIsLoadingoPersona,
  useControlEscolaroAlumno,
} from "store/selectors"
// #endregion

// #region actions
import {
  getControlEscolarGetPersona as onGetControlEscolarGetPersona,
  putControlEscolarPutPersona as onPutControlEscolarPutPersona,
  ControlEscolarUnsetError,
  ControlEscolarUnsetNotificacion,
  postControlEscolarSendPassword as onPostControlEscolarSendPassword,
  postControlEscolarUploadPhoto,
  getControlEscolarGetAlumno as onGetControlEscolarGetAlumno,
} from "../../store/actions"
import { use } from "react"
// #endregion

const DetallesModal = ({
  show,
  onDeleteClick,
  onCloseClick,
  oAlumno,
  isEdit,
}) => {
  console.log("oAlumno:", oAlumno)
  //
  // #region Init

  // #endregion

  // #region const-selectors
  const isAdministradorGeneral = useAuthPermiso(["sis_administrador_general"])
  const notificacion = useControlEscolaroNotificacion()
  const error = useControlEscolarError()
  const idPersonaAuthenticated = useAuthIdPersonaAuthenticated()
  const oPhotoCredencial = useControlEscolaroPhotoCredencial()
  const oPersona = useControlEscolaroPersona()
  const isLoadingoPersona = useControlEscolarIsLoadingoPersona()
  const oAlumnoFull = useControlEscolaroAlumno()
  // #endregion

  // #region useRef

  // #endregion

  // #region react-redux
  const dispatch = useDispatch()
  // #endregion

  // #region Internal States
  const [customActiveTab, setcustomActiveTab] = useState("1")
  // #endregion

  // #region useEffects

  // GetPersona
  useEffect(() => {
    //console.log("useEffect(() =>")
    dispatch(
      onGetControlEscolarGetPersona({
        nombreSolicitud: "getopersona",
        idAlumno: oAlumno.id_Alumno,
      })
    )
  }, [dispatch, oAlumno])

  // oPersona
  useEffect(() => {
    console.log("oPersona", oPersona)
  }, [oPersona])

  // error
  useEffect(() => {
    if (error && error.length) {
      toast.error(error, {
        autoClose: 2000,
      })
      dispatch(ControlEscolarUnsetError())
    }
  }, [error])
  // #endregion

  // #region functions

  // #endregion

  const toggleCustom = tab => {
    if (customActiveTab !== tab) {
      setcustomActiveTab(tab)
    }
  }
  return (
    <Row>
      <Col>
        <Nav tabs className="nav-tabs-custom nav-justified">
          <NavItem>
            <NavLink
              style={{ cursor: "pointer" }}
              className={classnames({
                active: customActiveTab === "1",
              })}
              onClick={() => {
                toggleCustom("1")
              }}
            >
              <span className="d-block d-sm-none">
                <i className="fas fa-home"></i>
              </span>
              <span className="d-none d-sm-block">Detalles</span>
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              style={{ cursor: "pointer" }}
              className={classnames({
                active: customActiveTab === "2",
              })}
              onClick={() => {
                toggleCustom("2")
              }}
            >
              <span className="d-block d-sm-none">
                <i className="far fa-user"></i>
              </span>
              <span className="d-none d-sm-block">Dirección</span>
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              style={{ cursor: "pointer" }}
              className={classnames({
                active: customActiveTab === "3",
              })}
              onClick={() => {
                toggleCustom("3")
              }}
            >
              <span className="d-block d-sm-none">
                <i className="far fa-envelope"></i>
              </span>
              <span className="d-none d-sm-block">Datos Académicos</span>
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              style={{ cursor: "pointer" }}
              className={classnames({
                active: customActiveTab === "4",
              })}
              onClick={() => {
                toggleCustom("4")
              }}
            >
              <span className="d-block d-sm-none">
                <i className="fas fa-cog"></i>
              </span>
              <span className="d-none d-sm-block">Documentación</span>
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              style={{ cursor: "pointer" }}
              className={classnames({
                active: customActiveTab === "5",
              })}
              onClick={() => {
                toggleCustom("5")
              }}
            >
              <span className="d-block d-sm-none">
                <i className="fas fa-cog"></i>
              </span>
              <span className="d-none d-sm-block">Cargos</span>
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              style={{ cursor: "pointer" }}
              className={classnames({
                active: customActiveTab === "6",
              })}
              onClick={() => {
                toggleCustom("6")
              }}
            >
              <span className="d-block d-sm-none">
                <i className="fas fa-cog"></i>
              </span>
              <span className="d-none d-sm-block">Kardex</span>
            </NavLink>
          </NavItem>
        </Nav>

        <TabContent activeTab={customActiveTab} className="p-3 text-muted">
          <TabPane tabId="1">
            <Row>
              <Col sm="12">
                <DatosGenerales
                  idAlumno={oAlumno.id_Alumno}
                  oPersona={oPersona}
                  isEdit={isEdit}
                />
              </Col>
            </Row>
          </TabPane>
          <TabPane tabId="2">
            <Row>
              <Col sm="12">
                <Direccion
                  idAlumno={oAlumno.id_Alumno}
                  oPersona={oPersona}
                  isEdit={isEdit}
                />
              </Col>
            </Row>
          </TabPane>
          <TabPane tabId="3">
            <Row>
              <Col sm="12">
                <DatosAcademicos
                  oAlumnoLight={oAlumno}
                  oPersona={oPersona}
                  isEdit={isEdit}
                />
              </Col>
            </Row>
          </TabPane>
          <TabPane tabId="4">
            <Row>
              <Col sm="12">
                {/* <Documentacion
                  oAlumno={oAlumno}
                  oPersona={oPersona}
                  isEdit={isEdit}
                /> */}
              </Col>
            </Row>
          </TabPane>
          <TabPane tabId="5">
            <Row>
              <Col sm="12">{/* <Cargos /> */}</Col>
            </Row>
          </TabPane>
          <TabPane tabId="6">
            <Row>
              <Col sm="12">{/* <Kardex /> */}</Col>
            </Row>
          </TabPane>
        </TabContent>
      </Col>
    </Row>
  )
}

DetallesModal.propTypes = {
  onCloseClick: PropTypes.func,
  onDeleteClick: PropTypes.func,
  show: PropTypes.any,
}

export default DetallesModal
